// extracted by mini-css-extract-plugin
export default {"bg":"Content_bg__QIjXs","head":"Content_head__F03Ok","cardWrap":"Content_cardWrap__Lol4v"};